import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NmInput } from '../input/input';

declare let $: any;

@Component({
	selector: 'nm-checkbox',
	templateUrl: './checkbox.html',
	styleUrls: ['./checkbox.css'],
	providers: [
		{
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: forwardRef(() => NmCheckbox),
	    multi: true,
	  }
  ]
})
export class NmCheckbox extends NmInput {
	@Input() checkedValue: any = true; // checked value
	@Input() uncheckedValue: any = false; // unchecked value

	public onInputChange(event: any): void {
		let elem = $(this.elementRef.nativeElement).find('input[type="checkbox"]');
		if(elem.prop('checked'))
			this.onChange(this.checkedValue);
		else
			this.onChange(this.uncheckedValue);
	}

	public writeValue(value: any): void {
		super.writeValue(value);

		let elem = $(this.elementRef.nativeElement).find('input[type="checkbox"]');
		if(value == this.checkedValue)
			elem.prop('checked', true);
		else
			elem.prop('checked', false);
	}
}


// WEBPACK FOOTER //
// ./src/widgets/checkbox/checkbox.ts